import {IGameFilterDefinition} from '../game-filter-definition.interface';
import {GameInfo} from '../../../games/game-info';
import {ApplyGameFilterResult} from "../../evaluators/game-filter-evaluator.interface";

export class VendorFilterDefinition implements IGameFilterDefinition {
  constructor(public readonly id: string,
              private readonly _vendorName: string,
              public readonly vendorIds: number[],
              private readonly _text?: string) {

  }
  get text(): string {
    if(this._text) {
      return this._text;
    }
    return this._vendorName;
  }

  applyFilter(gameInfo: GameInfo): ApplyGameFilterResult {
    if(this.vendorIds.includes(gameInfo.vendorId)) {
      return ApplyGameFilterResult.IncludeGame;
    }
    return ApplyGameFilterResult.ExcludeGame;
  }

  readonly subFilters: IGameFilterDefinition[] = [];
}
